import Layout from "../components/Layout";
import LeftSidebar from "../components/LeftSidebar";
import MessageContainer from "../components/MessageContainer";

const EndToEnd = () => {
  return (
    <Layout>
      <div className="grid sm:grid-cols-1 md:grid-cols-4 h-full">
        <div className="col-span-1">
          <LeftSidebar />
        </div>
        <div className="col-span-3">
          <MessageContainer />
        </div>
      </div>
    </Layout>
  );
};

export default EndToEnd;
